<template>
	<v-col class="reward">
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Reward Saya</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-medal</v-icon>
			<div class="pl-2">Reward</div>
			<div class="px-2">/</div>
			<div>Reward Saya</div>
		</div>

		<div class="mt-5">
			<v-row>
				<v-col cols="12">
					<v-card class="pa-3 elevation-0 rounded-lg hover-shadow">
						<v-tabs class="tabs-vo no-slider">
							<v-tab elevation="2" @click="showReward = 'rewardTitik'"><template v-if="showReward === 'rewardTitik'"><v-icon dense class="mr-1">mdi-medal-outline</v-icon></template>Reward Titik</v-tab>
							<v-tab @click="showReward = 'rewardPribadi'"><template v-if="showReward === 'rewardPribadi'"><v-icon dense class="mr-1">mdi-medal-outline</v-icon></template>Reward Pribadi</v-tab>
							<v-tab @click="showReward = 'rewardGrup'"><template v-if="showReward === 'rewardGrup'"><v-icon dense class="mr-1">mdi-medal-outline</v-icon></template>Reward Grup</v-tab>
						</v-tabs>
					</v-card>
				</v-col>
			</v-row>
		</div>

		<template>
			<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
				<div class="mt-5" v-if="showReward === 'rewardTitik'">
					<HistoryRewardTitik :currentPoint="listHistoryRewardPoint"></HistoryRewardTitik>
				</div>
			</v-scroll-x-reverse-transition>
			<v-scroll-x-transition mode="in-out" :hide-on-leave="true">
				<div class="mt-5" v-if="showReward === 'rewardPribadi'">
					<HistoryRewardPribadi :currentPoint="listHistoryRewardPoint"></HistoryRewardPribadi>
				</div>
			</v-scroll-x-transition>
			<v-scroll-x-transition mode="in-out" :hide-on-leave="true">
				<div class="mt-5" v-if="showReward === 'rewardGrup'">
					<HistoryRewardGroup :currentPoint="listHistoryRewardPoint"></HistoryRewardGroup>
				</div>
			</v-scroll-x-transition>
		</template>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import HistoryRewardTitik from './components/HistoryRewardTitik';
import HistoryRewardPribadi from './components/HistoryRewardPribadi';
import HistoryRewardGroup from './components/HistoryRewardGroup';

export default {
	components: {
		HistoryRewardTitik, HistoryRewardPribadi, HistoryRewardGroup
	},
	data() {
		return {
			loading: false,
			page: 1,
			limit: '10',
			listLimit: [ '10', '20', '50', '100' ],
			showReward: 'rewardTitik',
		}
	},
	computed: {
		...mapState('reward', ['listHistoryRewardPoint']),
	},
	methods: {
		...mapActions('reward', ['getHistoryRewardTitik', 'getHistoryRewardPoint']),

		getData() {
			this.getHistoryRewardTitik(this.queryString({limit:this.limit, page: this.page, params:this.params}))
				.then(() => {
					document.body.scrollTop = 0
					document.documentElement.scrollTop = 0
				})
		},
	},
	async created(){
		await this.$store.dispatch('setPageTitle', `Reward Saya`)
		await this.getHistoryRewardPoint()
		this.getData()
	}
};
</script>

